module.exports = __webpack_public_path__ + "media/2x/Q-1f1dfe39.png";